import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, StatusMark, NotYetImplemented, MenuPopover, MenuItem, ConfirmDialog } from '../../components/ui';
import { formatCredits } from '../../utils/credits';
import { deleteTemplate } from '../../api/templatesApi';
import { formatRanAt } from './homeData';

export default function TaskCard({ task, onDeleted, now }) {
  const [confirming, setConfirming] = useState(false);
  const [error, setError] = useState(false);
  const { id, title, steps, pinned, lastRun } = task;
  const href = `/tasks/${encodeURIComponent(id)}`;

  const confirmDelete = async () => {
    setError(false);
    try {
      await deleteTemplate(id);
      onDeleted(id);
    } catch (e) {
      setError(true);
    }
  };

  return (
    <Card variant={pinned ? 'lifted' : 'static'} className="p-[18px] flex flex-col gap-2.5 min-h-[178px]">
      <div className="flex justify-between items-start gap-2.5">
        <div className="font-bold text-[17px] leading-snug text-ink">{title}</div>
        <MenuPopover label={`More actions for ${title}`}>
          <NotYetImplemented feature="pinTasks">
            <MenuItem>Pin to top</MenuItem>
          </NotYetImplemented>
          <NotYetImplemented feature="orgPublic">
            <MenuItem>Make public in your organisation</MenuItem>
          </NotYetImplemented>
          <MenuItem onClick={() => { setError(false); setConfirming(true); }}>Delete</MenuItem>
        </MenuPopover>
      </div>
      <div className="text-[13px] text-pencil font-mono flex items-center gap-1 flex-wrap">
        <span>
          {steps} steps
          {lastRun && ` · ran ${formatRanAt(lastRun.at, now || new Date())} `}
        </span>
        {lastRun && <StatusMark status={lastRun.status} />}
        {lastRun && lastRun.status === 'failed' && lastRun.failedStep != null && (
          <span>step {lastRun.failedStep} failed</span>
        )}
        {lastRun && lastRun.costCredits != null && <span>· {formatCredits(lastRun.costCredits)}</span>}
      </div>
      <div className="mt-auto flex gap-2 items-center">
        <Button asChild variant="primary" size="sm"><Link to={`${href}/run`}>Run ▸</Link></Button>
        <Button asChild variant="secondary" size="sm"><Link to={href}>Open</Link></Button>
        {pinned && <span className="ml-auto text-xs font-bold bg-eraser px-2 py-0.5 rounded-md">PINNED</span>}
      </div>
      <ConfirmDialog
        open={confirming}
        title={`Delete ${title}?`}
        confirmLabel="Delete"
        error={error ? 'Couldn’t delete. Try again.' : undefined}
        onConfirm={confirmDelete}
        onCancel={() => setConfirming(false)}
      />
    </Card>
  );
}
